import { useEffect } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { getErrorToast } from "../utilities/toastUtility";
import { getAllErrorMessages } from "../utilities/formsUtility";

export const useFormValidationMessages = <T extends FieldValues>(
  form: UseFormReturn<T>
) => {
  const { errors } = form.formState;

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timer = setTimeout(() => {
        getErrorToast(getAllErrorMessages<T>(errors));
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [errors]);
};
